
import React from 'react'
import { Table } from 'react-bootstrap'
import useTranslation from '../../../Hooks/UseTranslation'
import { useProgrammation } from '../../../Hooks/UseProgrammation'

import './ItemsList.scss'

interface Props {
  items: any[]
}

const ItemsList = ({ items }: Props) => {

  const { t } = useTranslation()

  const { openItem } = useProgrammation()

  return (
    <div className="items-list table-responsive">
      <Table bordered className='table-group-items' style={{ minWidth: 500 }}>
        <thead>
          <tr>
            <th style={{ width: 50 }}>
              {t('PROGRAMMATION_MANAGER:SubItemsTableType')}
            </th>
            <th style={{ width: 50 }}>
              {t('PROGRAMMATION_MANAGER:SubItemsTableColor')}
            </th>
            <th>
              {t('PROGRAMMATION_MANAGER:SubItemsTableName')}
            </th>
            <th style={{ width: 100 }}>
              {t('PROGRAMMATION_MANAGER:SubItemsTableConstraints')}
            </th>
            <th style={{ width: 50 }}>
            {t('PROGRAMMATION_MANAGER:SubItemsTableProgress')}
            </th>
          </tr>
        </thead>
        <tbody>
          {items.map((item: any, i: number) => (
            <tr key={i} draggable="true" className='cursor-pointer'
              onClick={() => {

                if (item.type === 'task') {

                  openItem(item.task._id)
                } else {

                  openItem(item.group._id)
                }
              }}
            >
              <td style={{ textAlign: 'center' }}>
                {item.type === 'task' && item.task.type[0].toUpperCase()}
              </td>
              <td style={{ textAlign: 'center' }}>
                {item.type === 'task' && item.task.colorCode && (
                  <div className='color-code' style={{ backgroundColor: item.task.colorCode.color }}></div>
                )}
              </td>
              <td>
                {item.type === 'group' && (
                  <span style={{ fontWeight: 'bold' }}>
                    {item.group.name}
                  </span>
                )}
                {item.type === 'task' && item.task.name}
              </td>
              <td>

              </td>
              <td style={{ textAlign: 'right' }}>
                {item.type === 'task' && item.task.type !== 'hito' && item.task.type !== 'reunion' && `${item.task.progress}%`}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  )
}

export default ItemsList